import { CSSProperties } from "react";
import AlertIcon from "../Icons/AlertIcon";

const containerStyle: CSSProperties = {
  paddingTop: "108px",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  fontFamily: "Source Sans Pro",
  justifyContent: "center",
  gap: "12px",
};

const headingStyle: CSSProperties = {
  fontWeight: 600,
  color: "#373738",
  textAlign: "center",
  fontSize: "18px",
  fontStyle: "normal",
  lineHeight: "28px",
};

const textStyle: CSSProperties = {
  color: "#373738",
  textAlign: "center",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
};

const boldTextStyle: CSSProperties = {
  ...textStyle,
  fontWeight: 600,
  lineHeight: "24px",
};

const footerTextStyle: CSSProperties = {
  ...textStyle,
  paddingTop: "48px",
};

const ErrorPage = () => {
  return (
    <div style={containerStyle}>
      <AlertIcon />
      <span style={headingStyle}>
        Oops! We’re Having Trouble Loading the App
      </span>
      <span style={textStyle}>
        It looks like the application didn’t load properly. Please try these
        quick steps:
      </span>
      <span style={boldTextStyle}>1. Close and re-load the application</span>
      <span style={boldTextStyle}>2. Check your internet connection</span>
      <span style={footerTextStyle}>
        Still having trouble? Reach out to our Helpdesk, and we’ll be happy to
        help.
      </span>
      <span>877-635-0518</span>
      <span style={{ paddingTop: "24px" }}>Thanks for your patience!</span>
    </div>
  );
};

export default ErrorPage;
